import request from '@/utils/request'

export function moreInfo (query) {
  return request({
    url: '/api/allItems',
    method: 'get',
    params: query
  })
}